<template>
    <div class="game-section" v-if="gameArr != null" id="menu-link-game">
        <div class="container">
            <sectionTitle :options="[{ title : gameArr.game_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: gameArr.game_quote_img, title : gameArr.game_quote_title, desc: gameArr.game_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : gameArr.game_desc_left, desc_right: gameArr.game_desc_right}]" class="section-desc-column-game"></sectionDescColumn>
            <sectionImagesMobileSecond :options="[{ images: gameArr.game_images_mobile}]" v-if="isMobileGlobal"></sectionImagesMobileSecond>
            <sectionImagesGrid :options="[{ cards: gameArr.game_cards, init_desc : false}]" class="section-images-grid-second-game"></sectionImagesGrid>
            <div class="game-section-desc-mobile" v-if="isMobileGlobal">
                <p>{{gameArr.game_desc_right[1].desc}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesGrid from '@/components/partials/section-images-grid-second.vue'
    import sectionImagesMobileSecond from '@/components/partials/section-images-mobile-second.vue'

    import {mapGetters} from 'vuex'
    export default {
        name: 'game-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            gameArr: 'loadGameArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesGrid,
            sectionImagesMobileSecond,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/game/game-section.scss';
    @import '@/styles/components/game/game-section-respond.scss';
</style>